<template>
    <div>

        <b-container>
            <b-row>
                <b-col>
                    <h3>Past Orders</h3>
                    <Brewerorderscomponent  :ordersArray="pastOrders" :status = 2  />
                </b-col>
            </b-row>

        </b-container>
        
        
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import Brewerorderscomponent from './Brewerorderscomponent'
    const fb = require('../firebaseConfig.js')
    export default {
        components: {
            Brewerorderscomponent
            },
        computed: {
            ...mapState(['userProfile', 'currentUser', 'pastOrders', ])
        },
        methods:{
        }
        
    }
</script>